import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import './News.css';
import Breadcrumb from '../../components/Breadcrumb';
import Tabs from '../../components/Tabs';
import NewsGrid from '../NewsGrid';
import Config from '../../config/config';
import ScrollToTopOnMount from '../../components/ScrollToTopOnMount';

class News extends Component {
  constructor() {
    super();
    this.state = {
      newsTypes: [],
    };
  }

  componentDidMount() {
    fetch(`${Config.apiUrl}/newstypes`)
      .then(results => results.json())
      .then((data) => {
        this.setState({ newsTypes: data });
      });
  }

  render() {
    const { match } = this.props;
    // const currentType = match.params.filter;
    const tabs = [{ title: '所有訊息', link: '/news/all', stateIdentifier: 'all' }].concat(this.state.newsTypes.map(elem => ({
      title: elem.title,
      link: `/news/${elem.name}`,
      stateIdentifier: elem.name,
    })));
    const newsTypeNames = this.state.newsTypes.map(elem => elem.name);
    return (
      <section className="section">
        <ScrollToTopOnMount />
        <div className="news container">
          <Breadcrumb {...this.props} />
          <Tabs tabs={tabs} {...this.props} />
          <div className="outter-container">
            <div className="inner-container">
              <NewsGrid isShortNews enablePagination {...this.props} />
            </div>
          </div>
          {match.params.filter !== 'all' &&
            match.params.filter !== 'detail' &&
            newsTypeNames.indexOf(match.params.filter) === -1 && <Redirect to="/news/all" />}
        </div>
      </section>
    );
  }
}

News.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      filter: PropTypes.string,
    }),
  }),
};

News.defaultProps = {
  match: {
    params: {
      filter: '',
    },
  },
};

export default News;



// WEBPACK FOOTER //
// ./src/containers/page/News.js